<template>
  <OButton size="xs" :color-scheme="'red'" class="absolute z-1 right-0 top-0 h-8 w-8 u-center !p-0" @click="handleDeleteArticle">
    <OIcon icon="trash-white" class="w-5" />
  </OButton>
</template>

<script>
import { defineComponent, useContext, inject } from '@nuxtjs/composition-api';
import { useProfile } from '~/modules/profile/state/useProfile';
import { useDialog, useToast } from '~/composables/useModal';
import { useLoading } from '~/composables/useLoading';
import { OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OButton, OIcon },
  setup() {
    const article = inject('article', null);
    const { i18n } = useContext();
    const { deleteArticle } = useProfile();
    const { openErrorDialog, openDialog } = useDialog();
    const { toastSuccess } = useToast();
    const loading = useLoading();

    const handleDeleteArticle = (e) => {
      e.preventDefault();
      openDialog({
        description: i18n.t('article-card-profile.dialog-text-1'),
        actions: [
          { text: i18n.t('main.dialog.cancel') },
          {
            text: i18n.t('main.dialog.delete'),
            type: 'danger',
            action: async (closeDialog) => {
              loading.start();
              try {
                await deleteArticle(article._id);
                toastSuccess(i18n.t('article-card-profile.dialog-text-2'));
              } catch (error) {
                openErrorDialog({ error });
              } finally {
                loading.stop();
              }
              closeDialog();
            },
          },
        ],
      });
    };
    return { handleDeleteArticle };
  },
});
</script>
